import { render } from "./FiltersSection.vue?vue&type=template&id=8df2da84&scoped=true"
import script from "./FiltersSection.vue?vue&type=script&lang=js"
export * from "./FiltersSection.vue?vue&type=script&lang=js"

import "./FiltersSection.vue?vue&type=style&index=0&id=8df2da84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8df2da84"]])

export default __exports__